export * from "./RegisterDeviceInput";
